import { useCallback, useEffect, useState } from "react";
import Authenticator from "./authenticator";
import VerifyAuthenticator from "./verify.authenticator";
import apiCalls from "src/api/apiCalls";
import RecoveryCodes from "./recovery.code";
import ResetAuthenticator from "./reset.authenticator";
import Loader from "src/components/loader.component";
import { Alert } from "antd";
import { isErrorMessage } from "src/components/shared/error.message";
const AuthenticatorSteps = () => {
    const [currentStep, setCurrentStep] = useState(1);
    const [twofaGetData, setTwofaGetData] = useState()
    const [errorMessage, setErrorMessage] = useState(null)
    const [loader, setLoader] = useState(true)
    const [verifyAuthenticationObj, setVerifyAuthenticationObj] = useState(null);
    const [resetGetData, setResetGetData] = useState(null)
    useEffect(() => {
        hasAuthenticator()
    }, [])
    const getAuthenticatorData = useCallback(async () => {
        setLoader(true);
        try {
            const response = await apiCalls.authenticatorData();
            if (response.ok) {
                setTwofaGetData(response.data);
            } else {
                setErrorMessage(isErrorMessage(response.data));
            }
        } catch (error) {
            setErrorMessage(error);
        } finally {
            setLoader(false);
        }
    }, []);
    const hasAuthenticator = useCallback(async () => {
        setLoader(true);
        try {
            const response = await apiCalls.getHasAuthenticator();
            if (response.ok) {
                setResetGetData(response.data);
                getAuthenticatorData();
            } else {
                setErrorMessage(isErrorMessage(response?.data));
            }
        } catch (error) {
            setErrorMessage(error);
        } finally {
            setLoader(false);
        }
    }, [getAuthenticatorData]);
    const handleVerifyCode = useCallback(() => {
        setCurrentStep((prevStep) => prevStep + 1);
    }, [])
    const handleVerifyAuthenticator = useCallback(() => {
        setCurrentStep((prevStep) => prevStep - 1);
    }, [])

    const handleRecoveryCodes = useCallback((data) => {
        setVerifyAuthenticationObj(data);
    }, []);
    const handleError = useCallback((error) => {
        if (error) {
            setErrorMessage(isErrorMessage(error));
        } else {
            setErrorMessage(null);
        }
    }, []);
    const verifyTheAuth = useCallback((count) => {
        setCurrentStep((prevStep) => prevStep - count);
        if (count !== 1) {
            hasAuthenticator();
        }
    }, [hasAuthenticator]);
    const closeError = useCallback(() => {
        setErrorMessage(null)
    }, [])
    return (
        <>
            {loader && <><div className="h-[50vh] flex justify-center items-center"><Loader className="" /></div></>}
            {!loader && <>
                {errorMessage &&
                    <div className='mb-4'>
                        <Alert
                            className='mb-4'
                            type="error"
                            description={errorMessage}
                            showIcon
                            closable
                            onClose={closeError}
                        />
                    </div>}
                {resetGetData && <ResetAuthenticator getResetTwoFa={hasAuthenticator} />}
                {(!resetGetData && twofaGetData) && <>
                    <div className="steps-container">
                        <ul className="steps">
                            <li className={`step ${currentStep === 1 ? 'active !text-menuhoverColor' : 'inactive !text-whiteText'}`}>
                                <span className="step-number">1</span>
                                <span className="step-text">Authenticator <br /> App</span>
                            </li>
                            <li className={`step ${currentStep === 2 ? 'active !text-menuhoverColor' : 'inactive !text-whiteText'}`}>
                                <span className="step-number">2</span>
                                <span className="step-text">Verify the <br /> Authenticator</span>
                            </li>
                            <li className={`step ${currentStep === 3 ? 'active !text-menuhoverColor' : 'inactive !text-whiteText'}`}>
                                <span className="step-number">3</span>
                                <span className="step-text">Recovery <br /> Codes</span>
                            </li>
                        </ul>
                    </div>
                    {currentStep === 1 && <Authenticator handleVerifyCode={handleVerifyCode} twofaGetData={twofaGetData} />}
                    {currentStep === 2 && <VerifyAuthenticator handleVerifyCode={handleVerifyCode} handleVerifyAuthenticator={handleVerifyAuthenticator} handleRecoveryCodes={handleRecoveryCodes} handleError={handleError} />}
                    {currentStep === 3 && <RecoveryCodes recoveryCodes={verifyAuthenticationObj} verifyTheAuth={verifyTheAuth} />}
                </>}
            </>}
        </>
    )
}
export default AuthenticatorSteps